import {RouteIcon} from '@logistics-frontend/blocks'
import {IconButton} from '@logistics-frontend/blocks/legacy'
import clsx from 'clsx'
import React, {useCallback} from 'react'

import {useSetBoundsSettings, useShouldBoundsSettings} from 'src/components/map-bounds'

import {useClasses} from './classes'

export const ResetBounds: React.FC = () => {
  const classes = useClasses()
  const setBoundsSettings = useSetBoundsSettings()
  const shouldBounds = useShouldBoundsSettings()

  const resetBounds = useCallback(() => {
    if (shouldBounds === false) {
      setBoundsSettings({shouldBounds: true})
    }
  }, [shouldBounds, setBoundsSettings])

  return (
    <>
      {shouldBounds === false && (
        <IconButton className={clsx(classes.button, classes.geolocationButton)} onClick={resetBounds}>
          <RouteIcon className={classes.icon} />
        </IconButton>
      )}
    </>
  )
}

export default ResetBounds
